<template functional>
<div :class="['day-col periods', { embedded: props.isEmbed, 'screen-lg': props.onTabletUp }]">
  <div class="icon-week">
    <img src="@assets/images/icon-morning.svg" />
  </div>
  <div class="icon-week">
    <img src="@assets/images/icon-midday.svg" />
  </div>
  <div class="icon-week">
    <img src="@assets/images/icon-evening.svg" />
  </div>
</div>
</template>

<script>
export default {
  functional: true,
  props: {
    isEmbed: {
      type: Boolean,
    },
    onTabletUp: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.day-col.periods {
  background-color: $color-body-bg;
  border-bottom: 1px solid $base-border-color;
  border-radius: 0 0 1rem 0;
  border-right: 1px solid $base-border-color;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  left: 0;
  margin-right: 2rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 10rem;
  position: fixed;
  z-index: 1;

  .icon-week img {
    height: 100%;
    margin: auto 0;
    padding: 8rem 0;
  }

  &.embedded {
    margin-top: 6rem;
  }

  &.screen-lg {
    display: block;
    height: 100%;
    margin-top: 0;
  }
}
</style>
